module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    月報表模組已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("報表中心 > 報表下載區 > 定期報表")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), (_vm.roleType === 99 || _vm.roleType === 30) ? _c('chart-share') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b69b523c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Chart/ChartDash.vue
// module id = 2539
// module chunks = 1